export const PageEmptyState = () => (
  <div className="bg-default h-screen w-screen flex justify-center items-center p-12">
    <div className="text-center">
      <h1 className="heading1 text-default mb-4">
        The information you are looking for could not be found
      </h1>
      <p className="heading3 text-default">Please try again...</p>
    </div>
  </div>
);
